import React from "react"
const CategoryConverter = categoriesArray => {
  let foodCategories = null
  if (categoriesArray.length === 1) {
    foodCategories = (
      <h2 className="category h4 text-center mb-0">
        Type de cuisine: {categoriesArray[0].name}
      </h2>
    )
  } else if (categoriesArray.length > 1) {
    let result = "Type de cuisine : "
    let next = ""
    categoriesArray.forEach((cat, key, array) => {
      if (key === 0) {
        next = cat.name + " | "
      } else if (key === array.length - 1) {
        next = cat.name
      } else {
        next = cat.name + ", "
      }
      result += next
    })
    foodCategories = <h2 className="category h4 text-center mb-0">{result}</h2>
  }

  return foodCategories
}

export default CategoryConverter
